import { render } from "./pop_environment.vue?vue&type=template&id=1fd836f5&scoped=true"
import script from "./pop_environment.vue?vue&type=script&lang=js"
export * from "./pop_environment.vue?vue&type=script&lang=js"

import "./css/pop_environment.scss?vue&type=style&index=0&id=1fd836f5&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/div2-univRenewal-trunk-production/web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fd836f5"]])

export default __exports__